import { makeStyles, Typography } from '@material-ui/core';
import { TypographyProps } from '@material-ui/core/Typography/Typography';
import { useTheme } from '@material-ui/styles';

import { CustomPalette } from '@/config/types';

export const TITLE_COLOR_ID = 'title';

export interface FontProps extends Omit<TypographyProps, 'color'> {
  color?: TypographyProps['color'] | typeof TITLE_COLOR_ID;
  uppercase?: boolean;
  strikethrough?: boolean;
}

export const Font = ({ color, uppercase, strikethrough, style, ...props }: FontProps) => {
  const { palette }: { palette: CustomPalette } = useTheme();

  const isTitleColor = color === TITLE_COLOR_ID;
  const typographyColor = isTitleColor ? 'inherit' : color;
  const colorStyle = isTitleColor
    ? {
        color: palette.text.title,
      }
    : {};

  const strikethroughStyle = strikethrough
    ? {
        color: palette.error.main,
        textDecoration: 'line-through',
      }
    : {};

  const defaultVariantMapping = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    subtitle1: 'span',
    subtitle2: 'span',
    body1: 'span',
    body2: 'span',
    caption: 'span',
  };

  const useStyles = makeStyles({
    uppercase: {
      textTransform: 'uppercase',
    },
  });

  const classes = useStyles();

  return (
    <Typography
      className={uppercase ? `${classes.uppercase} lining-typography` : 'lining-typography'}
      variantMapping={defaultVariantMapping}
      {...props}
      color={typographyColor}
      style={{ ...style, ...colorStyle, ...strikethroughStyle }}
    ></Typography>
  );
};
